import { render, staticRenderFns } from "./CoPilotPrompts.vue?vue&type=template&id=4e0496d9&scoped=true"
import script from "./CoPilotPrompts.vue?vue&type=script&lang=js"
export * from "./CoPilotPrompts.vue?vue&type=script&lang=js"
import style0 from "./CoPilotPrompts.vue?vue&type=style&index=0&id=4e0496d9&prod&scoped=true&lang=scss"
import style1 from "./CoPilotPrompts.vue?vue&type=style&index=1&id=4e0496d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0496d9",
  null
  
)

export default component.exports